import { ApiResponse, Service, ServiceFormData } from "../Types";
import { axiosClientv1 } from "./apiClient";

export const getServices = async (
  search?: string,
): Promise<ApiResponse<Service[]>> => {
  try {
    const response = await axiosClientv1.get("/services", {
      params: { search },
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load services.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const createService = async (
  data: ServiceFormData,
): Promise<ApiResponse<Service>> => {
  try {
    const response = await axiosClientv1.post("/services/create", data);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to create service.",
      data: {} as Service,
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const updateService = async (
  data: ServiceFormData & { id: string },
): Promise<ApiResponse<Service>> => {
  try {
    const response = await axiosClientv1.post("/services/update", data);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to update service.",
      data: {} as Service,
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const deleteService = async (
  id: string,
): Promise<ApiResponse<{ id: string }>> => {
  try {
    const response = await axiosClientv1.post("/services/delete", { id });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to delete service.",
      data: { id },
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};
